import React from 'react'
import PropTypes from 'prop-types'

const DataIntegrationIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="#FFF" fillRule="evenodd">
      <path d="M13.667 1.714l-.875.938 2.5 2.678H2.333v1.34h12.959l-2.5 2.678.875.938 4-4.286zM6.333 18.286l.875-.938-2.5-2.678h12.959v-1.34H4.708l2.5-2.678-.875-.938-4 4.286z" />
    </g>
  </svg>
)

DataIntegrationIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default DataIntegrationIcon
